import type { DependencyContainer } from 'tsyringe'
import { DITokens } from '@/di'

export const useGTM = (container: DependencyContainer) => {
  const profileStore = container.resolve(DITokens.ProfileStore)

  const sendGTMEvent = (event: AddToCartEvent | DeleteFromCartEvent | SellEvent | CompleteOrderFormEvent) => {
    if (typeof window === 'undefined') return
    if (!window.dataLayer) window.dataLayer = []

    if (profileStore.uid) {
      window.dataLayer.push({
        ...event,
        user_id: profileStore.uid
      })
    } else {
      window.dataLayer.push(event)
    }
  }

  return {
    sendGTMEvent
  }
}
